// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__dAPZ0","logo":"Footer_logo__5RVaY","rights":"Footer_rights__BCirF","socials":"Footer_socials__CMCMv"};